export const IS_NODE = process && !process.browser
export const IS_WEB = !IS_NODE && typeof document !== 'undefined'
export const IS_DEV = IS_NODE
  ? process.env.NODE_ENV === 'development'
  : /^(localhost|0\.0|192\.)/.test(window.location.hostname)
export const IS_SANDBOX = !IS_NODE && /^get-dev-/.test(window.location.hostname)
export const IS_PROD = IS_NODE ? process.env.NODE_ENV === 'production' : !IS_DEV

// TODO: read port from config for local..
let SITE_URL = IS_PROD
  ? `https://${IS_SANDBOX ? 'get-dev-8979.' : ''}snips.ai/`
  : 'http://localhost:5000/'
if (!IS_NODE) {
  SITE_URL = window.location.protocol + '//' + window.location.host + '/'
}
export { SITE_URL }

// export const DOCS_URL = 'https://docs.snips.ai'
export const LEGAL_PRIVACY_URL =
  'https://docs.snips.ai/additional-resources/legal-and-privacy'
export const PRIVACY_POLICY_URL =
  'https://docs.snips.ai/additional-resources/legal-and-privacy/website-privacy-policy'
// export const RELEASE_NOTES_URL =
//   'https://docs.snips.ai/additional-resources/release-notes'
// export const SNIPS_TROUBLESHOOTING_URL =
//   'https://docs.snips.ai/additional-resources/troubleshooting/troubleshooting-common-issues'

export const YOUTUBE_TUTORIALS_URL =
  'https://www.youtube.com/playlist?list=PLmOf6ALFW9aY_EZOYtTM27TqKSasHqZr_'
export const YOUTUBE_KEYNOTES_PLAYLIST_URL =
  'https://www.youtube.com/playlist?list=PLmOf6ALFW9aZ0WTHqomPeFW7tOwIuUyUL'
export const YOUTUBE_CONSOLE_TOUR_VIDEO_URL =
  'https://www.youtube.com/watch?v=nCMSeaqJTvo&t'

export const MEDIUM_TECH_BLOG_URL = 'https://medium.com/snips-ai/'
export const MEDIUM_HOW_TO_POSTS_URL =
  'https://medium.com/snips-ai/tagged/how-to'
// export const SNIPS_GITHUB_ISSUES_URL =
//   'https://github.com/snipsco/snips-issues/issues'

// export const SEED_DEV_KIT_LINK = 'https://www.seeedstudio.com/snips.html'

// export const CONSOLE_BASE_URL =
//   IS_PROD && !IS_SANDBOX
//     ? 'https://console.snips.ai'
//     : 'https://console-dev.snips.ai'
// // NOTE: console signup is now closed.
// export const CONSOLE_URL = CONSOLE_BASE_URL + '/login'

export const MAKERS_URL = 'https://makers.snips.ai/'

export const FACEBOOK_LINK = 'https://www.facebook.com/snipscompany'
export const TWITTER_LINK = 'https://twitter.com/snips'
export const LINKEDIN_LINK = 'https://www.linkedin.com/company/snips'
export const INSTAGRAM_LINK = 'https://www.instagram.com/snips.ai/'
// export const FORUM_LINK = 'https://forum.snips.ai'

export const SNIPS_WEBSITE_BLOG_PATH = '/blog'
// NOTE: this url redirects to third part jobs site,
// specified via S3. Using absolute snips url here to avoid duplicating
// the exact redirect url
export const JOBS_URL = 'https://snips.ai/jobs'

export const COOKIES_TRACKING_CONSENT_COOKIE_NAME = 'snipsCookiesAndTracking'

export const LANDED_ON_ENTERPRISE_PAGE =
  IS_WEB && window.location.pathname.startsWith('/enterprise')
